import React, { useEffect, useState, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  ImageOverlay,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { useDispatch, useSelector } from "react-redux";
import {
  addArea,
  clearAllMapState,
  deleteArea,
  setFileContent,
  setUploaderFlag,
} from "../../reducers/MapSlice";
import { useMap } from "react-leaflet/hooks";
import L from "leaflet";
import { useTranslation } from "react-i18next";
import { url } from "../../api/axios_client";
import { toast } from "react-toastify";
import {
  setFeaturesColumn,
  setLoadingfeatures,
} from "../../reducers/PredictionSlice";
import axios from "../../api/axios_client";
import AddGeoJson from "./AddGeojson";

function useShapeClearing() {
  const mapRef = useRef();
  
  const clearAllShapes = () => {
    if (mapRef.current) {
      const map = mapRef.current;
      map.eachLayer((layer) => {
        if (
          layer instanceof L.Polygon ||
          layer instanceof L.GeoJSON ||
          layer instanceof L.Circle ||
          layer instanceof L.Rectangle
        ) {
          map.removeLayer(layer);
        }
      });
    }
  };

  useEffect(() => {
    const handleClearShapes = () => {
      clearAllShapes();
    };

    // Listen for the custom event from CoordinatesInput
    window.addEventListener('clearDrawnShapes', handleClearShapes);

    return () => {
      window.removeEventListener('clearDrawnShapes', handleClearShapes);
    };
  }, []);

  return { mapRef, clearAllShapes };
}

// Component to access map instance and register it with the clearing hook
function MapInstanceRegistrar({ onMapReady }) {
  const map = useMap();
  
  useEffect(() => {
    if (map && onMapReady) {
      onMapReady(map);
    }
  }, [map, onMapReady]);

  return null;
}

function Map(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const center = { lat: 19.55979, lng: 29.267578 };

  const fileContent = useSelector(
    (state) => state.mapState.uploadedFileContent
  );
  const uploaderFlag = useSelector((state) => state.mapState.uploaderFlag);
  const [deleteState, setDelete] = useState(false);
 const { mapRef, clearAllShapes } = useShapeClearing();
  const _onCreated = (e) => {
    let layer = e.layer;
    dispatch(
      addArea({
        polyId: layer._leaflet_id,
        coordinates: layer.toGeoJSON().geometry.coordinates[0],
      })
    );
  };

  const _onDeleted = (e) => {
    const deletedKeys = Object.keys(e.layers._layers);
    dispatch(deleteArea(deletedKeys));
  };

   const handleMapReady = (map) => {
    mapRef.current = map;
  };

  function DeleteGeoJson() {
    const map = useMap();
    map.eachLayer(function (layer) {
      if (layer instanceof L.Polygon) {
        layer.remove();
      }
    });
    dispatch(setUploaderFlag(false));
    setDelete(false);
    dispatch(clearAllMapState());
  }

  function deleteUploadedFiles() {
    localStorage.removeItem("mapFileContent");
    dispatch(clearAllMapState());
    dispatch(setUploaderFlag(false));
    dispatch(setFileContent(""));
    setDelete(true);
  }

  const ArabWorldBounds = {
    southWest: {
      lat: -18.454445427710418,
      lng: -18.675611088484246,
    },
    northEast: {
      lat: 45.261019159784439,
      lng: 60.756334763925977,
    },
  };

  const bounds = L.latLngBounds(
    ArabWorldBounds.southWest,
    ArabWorldBounds.northEast
  );

  const areas = useSelector((state) => state.mapState.areas);

  function getBounds(coordinates) {
    const southwest = [coordinates[0][1], coordinates[0][0]]; // [longitude, latitude]
    const northeast = [coordinates[2][1], coordinates[2][0]]; // [longitude, latitude]

    // Define the bounds of the shape using southwest and northeast corners
    return [southwest, northeast];
  }

  return (
    <>
      <MapContainer
        bounds={bounds}
        maxBounds={bounds}
        center={center}
        minZoom={4}
      >
        <MapInstanceRegistrar onMapReady={handleMapReady} />
        {areas &&
          areas.map(
            (area, index) =>
              (area.imgurl || area.img64) && (
                <ImageOverlay
                  key={index}
                  url={
                    area.imgurl ||
                    (area.img64 && `data:image/png;base64,${area.img64}`)
                  } // Assuming imgurl contains the URL for the image
                  bounds={getBounds(area.coordinates)} // Assuming coordinates contains the bounds of the image overlay
                />
              )
          )}
        {fileContent && <AddGeoJson />}
        {deleteState && <DeleteGeoJson />}
        <TileLayer
          attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        />
        <FeatureGroup>
          <EditControl
            position="topleft"
            onCreated={_onCreated}
            onDeleted={_onDeleted}
            onDrawStart={(e) => {
              localStorage.removeItem("mapFileContent");
              dispatch(clearAllMapState());
              dispatch(setUploaderFlag(false));
              setDelete(true);

              const map = e.target;
              map.eachLayer((layer) => {
                if (
                  layer instanceof L.Polygon ||
                  layer instanceof L.GeoJSON ||
                  layer instanceof L.Circle ||
                  layer instanceof L.Rectangle
                ) {
                  map.removeLayer(layer);
                }
              });
            }}
            draw={{
              rectangle: true,
              circle: true,
              polyline: false,
              marker: false,
              polygon: true,
              circlemarker: false,
            }}
          />
        </FeatureGroup>
      </MapContainer>
      {uploaderFlag ? (
        <div className="remove-area">
          <button
            className="delete-button"
            onClick={() => deleteUploadedFiles()}
          >
            {t("Map.remove_file")}
          </button>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}

export default Map;
